// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/switch/style/index.less
// module id = 1067
// module chunks = 1